import $ from "jquery";
import debug from "bows";

const log = debug("jump");
const $jumpLink = $('.jump__link');
const $jumpSelect = $('.jump__select');

function jumpScroll(scrollVar) {
	let $where = $(scrollVar);
	let whereTo = $where.offset().top;

	$('html, body').animate({
		scrollTop: whereTo
	}, 500, 'swing');

	$where.attr('tabindex', -1).addClass('removetabindex').focus();
}

function jumpSelects() {
	let where = $(this).val();

	jumpScroll(where);
}

function jumpLinks() {
	let where = $(this).attr('href');

	jumpScroll(where);
}

function activateJump() {
	let $id = $('[id]');
	$id.each(function () {
		let current_id = '#' + $(this).attr('id');

		$(current_id).find('.jump__link[href="' + current_id + '"]').addClass('jump__link--active');
	});
	log($('[id]').length);
}

export function init() {
	if ($jumpLink.length) {
		$jumpLink.on('click', jumpLinks);
		activateJump();
	}

	if ($jumpSelect.length) {
		$jumpSelect.on('change', jumpSelects);
	}
}

export default {
	init
};
